<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import moment from "moment";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";

/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage,Layout, PageHeader },
  data() {
    return {
      title: "Hotel Markup Commission List",
      items: [
        {
          text: "Commission",
          href: "/",
        },
        {
          text: "Hotel Markup Commission List",
          active: true,
        },
      ],
      mcs: [],
        errors:null,
        visible:false,
        message:"",
        search:"",
    };
  },
  mounted() {
    this.getMCList();
  },
    computed: {
        filteredList() {
            return this.mcs.filter(mc => {
                return mc.uuid.toLowerCase().includes(this.search.toLowerCase())

            })
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      searchFilterFunc2(val) {
          this.search=val;
      },

      moment: function () {
      return moment();
    },
    async getMCList() {
      try {
        axios
          .get("/api/hotel_markup_com/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.mcs = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async deleteWarning(mc) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete Markup!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(mc);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    deleteItem: function deleteItem(mc) {
      var _this = this;
      axios
        .post("/api/hotel_markup_com/delete/" + mc.uuid, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
            if(response.data.status){
                _this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Successfully Delete Hotel DMC',
                    showConfirmButton: false,
                    timer: 1000
                });
                _this.getMCList();
                _this.hasDeleted = false;
            } else {
                var str = response.data.message;
                var jsonParse = JSON.parse(str);
                _this.errorCheck(jsonParse);
            }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout  @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Start DateTime</th>
                    <th>End DateTime</th>
                    <th>Destination</th>
                    <th>Country Code</th>
                    <th>Api Id</th>
                    <th>Check In Date</th>
                    <th>Check Out Date</th>
                      <th>Account Type</th>
                      <th>Hotel Name</th>
                    <th>markup Type</th>
                    <th>Markup Value</th>
                    <th>Commission Type</th>
                    <th>Commission Value</th>
                    <th>Exclude Destination</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(mc,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{ mc.start_dateTime | moment('ll')}}</td>
                    <td>{{ mc.end_dateTime | moment('ll')}}<span v-if="mc.end_dateTime==null">continue</span></td>
                    <td>{{mc.destination}}<span v-if="mc.destination==null">all</span></td>
                      <td>{{mc.country_code}}<span v-if="mc.country_code==null">all</span></td>
                      <td>{{mc.api_vendor==null ? 'all' : mc.api_vendor.api_provider}}</td>
                      <td>{{mc.check_in_date==null ? 'all' : mc.check_in_date | moment('ll')}}</td>
                      <td>{{mc.check_out_date==null ? 'all' : mc.check_out_date | moment('ll')}}</td>
                    <td>{{mc.account_type}}<span v-if="mc.account_type == null">all</span></td>
                    <td>{{mc.hotel_name}}<span v-if="mc.hotel_name==null">all</span></td>
                      <td>{{mc.markup_type}}<span v-if="mc.markup_type==null">none</span></td>
                      <td>{{mc.markup_value}}<span v-if="mc.markup_value==null">none</span></td>
                      <td>{{mc.commission_type}}<span v-if="mc.commission_type==null">none</span></td>
                      <td>{{mc.commission_value}}<span v-if="mc.commission_value==null">none</span></td>
                      <td>{{mc.exclude_destination}}<span v-if="mc.exclude_destination==null">all</span></td>

                    <td><router-link :to="{ name: 'hotel_markup_commission_update', params: {uuid: mc.uuid } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link> <button @click.prevent="deleteWarning(mc)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i> Delete</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
